(function () {
  'use strict';
  /* Quiz « Poils dans la maison » — hair_home_v1.
     TRACKING : une seule voie, Shopify.analytics.publish (API Evenements
     clients), soumise au consentement Shopify. Aucun fbq, aucun dataLayer,
     aucun stockage persistant.
     Les apostrophes des textes utilisent le caractere typographique ’. */
  var root = document.querySelector('[data-tp-quiz]');
  if (!root) return;
  var QUIZ_ID = root.dataset.quizId || 'hair_home_v1';
  var VARIANT = root.dataset.variant || 'B';
  var products = {};
  try { products = JSON.parse(root.querySelector('[data-tp-quiz-products]').textContent) || {}; } catch (e) { products = {}; }
  var utm = {};
  try { new URLSearchParams(window.location.search).forEach(function (v, k) { if (/^utm_/.test(k)) utm[k] = v; }); } catch (e) {}
  function track(name, data) {
    var payload = Object.assign({ quiz_id: QUIZ_ID, variant: VARIANT }, utm, data || {});
    try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(name, payload); } catch (e) {}
  }

  var produits = document.getElementById('produits');
  if (produits) produits.style.scrollMarginTop = '96px';

  var panel = root.querySelector('[data-tp-quiz-panel]');
  var steps = panel ? Array.prototype.slice.call(panel.querySelectorAll('[data-tp-quiz-step]')) : [];
  var progress = panel ? panel.querySelector('[data-tp-quiz-progress]') : null;
  var bar = panel ? panel.querySelector('[data-tp-quiz-bar]') : null;
  var backBtn = panel ? panel.querySelector('[data-tp-quiz-back]') : null;
  var nextBtn = panel ? panel.querySelector('[data-tp-quiz-next]') : null;
  var navEl = panel ? panel.querySelector('.tp-quiz__nav') : null;
  var stepsEl = panel ? panel.querySelector('[data-tp-quiz-steps]') : null;
  var resultEl = panel ? panel.querySelector('[data-tp-quiz-result]') : null;
  var answers = {}, step = 0, completed = false, viewed = false;

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function money(cents) { return window.ToudouPrice ? window.ToudouPrice.text(cents) : (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  function currentValue() { var r = steps[step] ? steps[step].querySelector('input:checked') : null; return r ? r.value : ''; }
  function setBar(ratio) { if (bar) bar.style.transform = 'scaleX(' + ratio + ')'; }
  function show(i) {
    step = i;
    steps.forEach(function (s, k) { s.hidden = k !== i; });
    if (progress) progress.textContent = 'Question ' + (i + 1) + ' sur 3';
    setBar((i + 1) / 3);
    if (backBtn) backBtn.hidden = i === 0;
    if (nextBtn) { nextBtn.textContent = i === 2 ? 'Voir ma solution' : 'Continuer'; nextBtn.disabled = !currentValue(); }
    var q = steps[i].querySelector('.tp-quiz__question'); if (q) q.focus({ preventScroll: true });
  }
  function petWord(p) { return p === 'dog' ? 'votre chien' : p === 'cat' ? 'votre chat' : 'vos compagnons'; }
  function issueWhy(issue) {
    var m = { home: 'Vous avez indiqué que les poils se retrouvent surtout sur vos tissus.', groom: 'Vous avez indiqué que les poils se détachent surtout pendant le brossage.', both: 'Vous avez indiqué des poils à la fois sur l’animal et dans la maison.', other: 'Vous cherchez avant tout à faciliter l’entretien du pelage.' };
    return m[issue] || '';
  }
  function resultFor(a) {
    if (a.goal === 'fast') return { key: 'A', kicker: 'Notre recommandation', title: 'Pour retirer les poils des tissus', cta: 'Découvrir le Rouleau Anti-Poils', why: issueWhy(a.issue) + ' Le rouleau récupère les poils de ' + petWord(a.pet) + ' sur le canapé, les vêtements et les tissus compatibles. Il ne remplace pas le brossage : il agit sur la maison.' };
    if (a.goal === 'routine') return { key: 'B', kicker: 'Notre recommandation', title: 'Pour faciliter votre routine de brossage', cta: 'Découvrir la Brosse Autonettoyante', why: issueWhy(a.issue) + ' La brosse retire les poils morts de ' + petWord(a.pet) + ' pendant le brossage, puis se vide d’un clic grâce à son bouton. Elle facilite le geste ; elle n’empêche pas la mue.' };
    return { key: 'C', kicker: 'Votre routine', title: 'Pour l’animal et la maison', cta: 'Découvrir ma routine', why: issueWhy(a.issue) + ' Le Pack Pelage & Maison réunit trois gestes réels : une brosse autonettoyante et une brosse de bain pour ' + petWord(a.pet) + ', et le rouleau pour les tissus.' };
  }
  function renderResult() {
    var r = resultFor(answers), p = products[r.key];
    if (!resultEl || !p) return;
    var benefits = (p.b || []).filter(Boolean).slice(0, 3).map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('');
    resultEl.innerHTML = '<div class="tp-quiz__result-card"><img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" width="180" height="180" loading="lazy"><div><p class="tp-quiz__result-kicker">' + esc(r.kicker) + '</p><h3 class="tp-quiz__result-title" tabindex="-1">' + esc(r.title) + '</h3><p class="tp-quiz__result-why">' + esc(r.why) + '</p>' + (benefits ? '<ul class="tp-quiz__result-benefits">' + benefits + '</ul>' : '') + '<div class="tp-quiz__result-actions"><a class="btn btn--primary btn--small" href="' + esc(p.url) + '" data-tp-quiz-cta data-result="' + r.key + '" data-product-id="' + p.id + '">' + esc(r.cta) + ' · ' + esc(money(p.price)) + '</a><a class="tp-quiz__link" href="#produits">Voir les autres solutions</a><button type="button" class="tp-quiz__link" data-tp-quiz-restart>Recommencer</button></div></div></div>';
    if (stepsEl) stepsEl.hidden = true; if (navEl) navEl.hidden = true;
    if (progress) progress.textContent = 'Votre résultat';
    setBar(1);
    resultEl.hidden = false;
    var h = resultEl.querySelector('.tp-quiz__result-title'); if (h) h.focus({ preventScroll: true });
    track('quiz_result_view', { result_id: r.key, product_id: p.id });
  }
  function restart(silent) {
    answers = {}; completed = false;
    steps.forEach(function (s) { s.querySelectorAll('input').forEach(function (i) { i.checked = false; }); });
    if (resultEl) { resultEl.hidden = true; resultEl.innerHTML = ''; }
    if (stepsEl) stepsEl.hidden = false; if (navEl) navEl.hidden = false;
    show(0);
    if (!silent) track('quiz_start', { restart: true });
  }

  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-tp-quiz-start]')) { if (!panel) return; panel.hidden = false; restart(true); track('quiz_start'); panel.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }); return; }
    if (t.closest('[data-tp-quiz-skip]')) { track('quiz_skip'); return; }
    if (t.closest('[data-tp-quiz-close]')) { panel.hidden = true; var s = root.querySelector('[data-tp-quiz-start]'); if (s) s.focus(); return; }
    if (t.closest('[data-tp-quiz-back]')) { if (step > 0) show(step - 1); return; }
    if (t.closest('[data-tp-quiz-restart]')) { restart(false); return; }
    var cta = t.closest('[data-tp-quiz-cta]');
    if (cta) { track('quiz_product_click', { result_id: cta.dataset.result, product_id: cta.dataset.productId }); return; }
    var card = t.closest('[data-tp-quiz-product]');
    if (card) { track('quiz_product_click', { result_id: 'grid_' + card.dataset.tpQuizProduct, product_id: card.dataset.productId }); return; }
    if (t.closest('[data-tp-quiz-next]')) {
      var v = currentValue(); if (!v) return;
      var qid = steps[step].dataset.tpQuizStep;
      answers[qid] = v;
      track('quiz_answer', { question_id: qid, answer_id: v, step: step + 1 });
      if (step < 2) { show(step + 1); return; }
      if (!completed) { completed = true; track('quiz_complete', { issue: answers.issue, pet: answers.pet, goal: answers.goal }); }
      renderResult();
    }
  });
  if (panel) panel.addEventListener('change', function (e) { if (e.target.matches('input[type="radio"]') && nextBtn) nextBtn.disabled = false; });

  if (panel && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting && !viewed && !panel.hidden) { viewed = true; track('quiz_view'); io.disconnect(); } });
    }, { threshold: 0.5 });
    io.observe(panel);
  }
  track('quiz_landing_view');
})();